import api from "../Api";
import routes from "../constants/ApiRoutesConstants";

export default async function GetCurrentUserSuppliers(params) {
  const res = await api.get(routes.GET_CURRENT_USERS_SUPPLIERS, {
    params: params,
  });
  return res;
}
